import { Component, OnInit, HostListener, ElementRef, NgZone, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
const $ = jQuery;
@Component({
  selector: 'app-cierant-searchable-table',
  templateUrl: './cierant-searchable-table.component.html',
  styleUrls: ['./cierant-searchable-table.component.scss']
})
export class CierantSearchableTableComponent implements OnInit, OnChanges {
  @HostListener('document:click', ['$event'])
  clickout(event) {
    const elementText = $(this.eRef.nativeElement).text();
    console.log()
  }
  itemsActive = false;
  searchTerm = "";
  @Input() loading = false;
  @Input() multiple: boolean;

  @Input() config = {
    searchableField: "name",
    titleField: "name",
    idField: 'id'
  }
  @Input() items = [];
  filteredItems = [];
  @Input() columns:{name, displayName}[] = [];
  @Output() itemsValueChange = new EventEmitter();

  constructor(
    private eRef: ElementRef,
    private ngZone: NgZone
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items) {
      this.items = changes.items.currentValue;
      this.filteredItems = this.items;
    }
  }

  setItems(items) {
    this.filteredItems = items || this.items;
  }

  ngOnInit() {
    this.filteredItems = this.items;
    const self = this;
    $(document).click(function(event) {
      //if you click on anything except the modal itself or the "open modal" link, close the modal
      if (!$(event.target).closest("app-cierant-dropdown-searchable,.cierant-searchable-selected-container,.cierant-searchable-selected-text,.cierant-searchable-content,.cierant-searchable-input,cierant-searchable-input [type=text],.cierant-searchable-item").length) {
        self.ngZone.run(() => {
          self.itemsActive = false;
        })
      }
    });
  }

  selectItem(item) {
    console.log(item);
    if (!this.multiple && this.items && this.items.filter(i => i.selected).length > 0) {
      this.items.find(i => i.selected).selected = false;
    }
    const idField = this.config.idField || 'id';
    this.items.find(i => i[idField] == item[idField]).selected = true;
    this.itemsValueChange.emit(this.items);
  }

  deselectITem(item) {
    const idField = this.config.idField || 'id';
    this.items.find(i => i[idField] == item[idField]).selected = false;
    this.itemsValueChange.emit(this.items);
  }

  getSelectedItems() {
    if (!this.items) {
      return [];
    }
    return this.items.filter(i => i.selected);
  }

  getNotSelectedItems() {
    if (!this.items) {
      return [];
    }
    console.log('this.searchTerm', this.searchTerm)
    if (this.searchTerm) {
      return this.items.filter(i => !i.selected && i[this.config.searchableField].toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1); 
    } else {
      return this.items.filter(i => !i.selected);
    }
  }

  searchItems() {
    if (!this.items) {
      return [];
    }
    if (!this.searchTerm) {
      this.filteredItems = this.items;
      return;
    }
    this.filteredItems = this.items.filter(i => i[this.config.searchableField].toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1);
  }

  getPlaceholder() {
    let placeholder = "Select...";
    const items = this.getSelectedItems();
    if (items && items.length > 0) {
      placeholder = items[0][this.config.searchableField];
      if (items.length > 1) {
        placeholder += ` + ${items.length - 1} more...`
      }
    }
    return placeholder;
  }

  resetSelected() {
    if (!this.items) {
      return;
    }
    this.items.forEach(item => {
      item.selected = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/cierant-searchable-table/cierant-searchable-table.component.ts